import React from "react";


//view component that displays BidPro logo

export const Logo = () => <img src="/pjsNewLogo.png" alt="PJs Pub Logo" className="logo"/>
    